import React from "react";
import { Outlet } from "react-router-dom";
import { styles } from "./styles";
import { RemittanceProgressStepper } from "../../ui";

export const InitiateRemittanceLayout = () => {
  return(
    <div className={styles.container.mainContainer}>
      <RemittanceProgressStepper />
      <div className={styles.container.outletContainer}>
        <Outlet />
      </div>
    </div>
  )
}